var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.4889 17.0972L16.3311 11.6768H11.0628V8.15932C11.0628 6.67638 11.7987 5.23094 14.1584 5.23094H16.5537V0.616269C16.5537 0.616269 14.3798 0.25 12.3016 0.25C7.96263 0.25 5.12678 2.84595 5.12678 7.54561V11.6768H0.303711V17.0972H5.12678V30.2008C6.09387 30.3506 7.08509 30.4286 8.09482 30.4286C9.10455 30.4286 10.0958 30.3506 11.0628 30.2008V17.0972H15.4889Z"}));
}

FacebookInline.defaultProps = {"width":"17","height":"31","viewBox":"0 0 17 31","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
